export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGIN_2FA = 'USER_LOGIN_2FA'
export const USER_DETAILS_UPDATE = 'USER_DETAILS_UPDATE'
export const USER_RESET = 'USER_RESET'
